import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.contacts.edit
function* editSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/contacts/${payload.id}`, { ...payload.data })
        if (response.success) {
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload.sagaCB?.onError) {
            yield payload.sagaCB?.onError()
        }
    }
}

function* editSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSagaTask)
}

export default editSaga
